import { render, staticRenderFns } from "./EditBookingAdditionalItemDIalog.vue?vue&type=template&id=105cd565"
import script from "./EditBookingAdditionalItemDIalog.vue?vue&type=script&lang=js"
export * from "./EditBookingAdditionalItemDIalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports